import React from 'react';

import classNames from 'classnames';

/**
 * One "Your items" tile: a title, a total, and the exception line under it.
 *
 * ALWAYS A BUTTON. Every tile opens the one detail panel below the row rather
 * than navigating, so there is no href to carry and nothing for a middle-click
 * to do. That is a change from the tile this replaced, which was an anchor
 * wherever it had a deep link.
 *
 * NO MODULE LABEL. The tile used to name where its rows live ("Procurement",
 * "R.A.D.I.O.") on a line of its own; six tiles carrying it turned the row into
 * a list of module names with numbers attached. The panel that opens still says
 * it, once, in its "View all in …" link.
 *
 * THE EXCEPTION LINE'S HEIGHT IS RESERVED WHETHER OR NOT IT RENDERS. A row of
 * six tiles where only two have something wrong would otherwise come out
 * ragged, and the tiles are meant to be scanned as one row.
 */
export default function HomeTile({ label, value, exceptionText, selected = false, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-pressed={selected}
            className={classNames(
                'tw-flex tw-w-full tw-flex-col tw-gap-1.5 tw-rounded-lg tw-border-2 tw-bg-white tw-px-4 tw-py-3 tw-text-start',
                selected ? 'tw-border-blue' : 'tw-border-grey hover:tw-border-blue-25',
            )}
        >
            <span className="tw-text-0.5sm tw-font-medium tw-text-charcoal">{label}</span>
            <span className="tw-text-2.5xl tw-font-bold tw-leading-none tw-text-charcoal">{value}</span>
            <span className={classNames('tw-min-h-4 tw-text-xs', exceptionText ? 'tw-font-semibold tw-text-red' : 'tw-text-charcoal-60')}>{exceptionText}</span>
        </button>
    );
}
